import { Theme } from '@mui/material/styles';
import { BorderColor } from '../model/BorderColor';

export const colors = ({ palette }: Theme, color: BorderColor): string => {
  const ColorsMap: Record<BorderColor, string> = {
    default: palette.grey[400],
    error: palette.error.main,
    info: palette.info.main,
    primary: palette.primary.main,
    success: palette.success.main,
    transparent: palette.transparent.default,
    warning: palette.warning.main,
  };
  return ColorsMap[color];
};

export const BorderMapper = {
  colors,
};
